import { QueryClient } from 'react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 10, // data will be in cache for 10 minutes
      cacheTime: 1000 * 60 * 10, // data will be in cache for 10 minutes
    },
  },
});
